//@flow
//$FlowFixMe
import React, { useEffect, useState } from 'react'
import {
  CompaniesTemplate,
  Invoices,
  Devices,
  AboutCompany,
  SearchIntercomModal,
  SendMoneyModal,
  ExpenseBillingModal,
  LinkDeviceModal,
  Tracks,
  Operations,
  Services,
  Analytics,
} from 'components'
import { connect } from 'react-redux'
import { withRouter, NavLink, Switch, Route } from 'react-router-dom'
import { Typography } from '@material-ui/core'
import { Select, Button } from 'sputnik-ui'
import { AttachMoney, Link } from '@material-ui/icons'

import type { Match } from 'react-router-dom'
import type { BillingAccount } from 'globalTypes'

import {
  fetchCompanies,
  fetchCompanyInvoices,
  fetchCompanyDevices,
  fetchCompanyInfo,
  fetchCompanyByIdentifier,
} from 'store/operations'
import { clearCompanyData, setSelectedCompany } from 'store/actions'
import * as _ from 'lodash'
import { getCompanyService, getServicesCatalog } from 'store/companies/operations'
import { useSelector } from 'react-redux'
import { More, Slash } from 'sputnik-icons'

const Tab = (props) => (
  <Typography
    variant="body1"
    component={NavLink}
    {...props}
    style={{
      color: 'rgba(0, 0, 0, 0.54)',
      marginRight: '1rem',
      textDecoration: 'none',
      textTransform: 'uppercase',
    }}
    activeStyle={{
      color: 'black',
    }}
  />
)

function CompaniesPage({
  dispatch,
  match,
  history,
  invoices,
  selectedCompany,
  ...props
}: Props) {
  useEffect(() => {
    if (selectedCompany) {
      const companyUuid = selectedCompany.value
      dispatch(getServicesCatalog('company'))
      dispatch(getCompanyService(companyUuid))
      dispatch(fetchCompanyInvoices(companyUuid))
      dispatch(fetchCompanyDevices({ companyUuid }))
      dispatch(fetchCompanyInfo({ companyUuid }))
    }

    return () => dispatch(clearCompanyData())
  }, [dispatch, selectedCompany])

  const { identifier } = match.params
  useEffect(() => {
    if (identifier && selectedCompany?.identifier !== identifier) {
      dispatch(fetchCompanyByIdentifier(identifier)).catch(() =>
        history.replace('/companies')
      )
    }
  }, [dispatch, history, identifier, selectedCompany])

  const handleSelect = (o) => {
    dispatch(setSelectedCompany(o))
    history.push(`/companies/${o.identifier}`)
  }

  const [intercomSearchOpen, setIntercomSearch] = useState(false)
  const handleIntercomSearch = (values) => {
    try {
      setIntercomSearch(false)
    } catch (error) {}
  }

  const loadCompaniesPromise = (q) => {
    return new Promise((resolve, reject) =>
      dispatch(fetchCompanies(q))
        .then((companies) => {
          const options = companies?.map((o) => ({
            label: o?.name,
            value: o?.uuid,
            identifier: o?.personal_account,
          }))
          resolve(options)
        })
        .catch(reject)
    )
  }

  const [sendMoneyModal, setSendMoneyModal] = useState(false)
  const [expenseBillingModal, setExpenseBillingModal] = useState(false)
  const [linkDeviceModal, setLinkDeviceModal] = useState(false)

  return (
    <CompaniesTemplate
      selectedCompany={!!selectedCompany}
      tabs={
        selectedCompany && (
          <>
            <Tab exact to={match.url}>
              Устройства
            </Tab>
            <Tab to={`${match.url}/operations`}>Операции</Tab>
            <Tab to={`${match.url}/invoices`}>Инвойсы</Tab>
            <Tab to={`${match.url}/about`}>О Компании</Tab>
            <Tab to={`${match.url}/tracks`}>Треки</Tab>
            <Tab to={`${match.url}/services`}>Услуги</Tab>
            <Tab to={`${match.url}/analytics`}>Аналитика</Tab>
          </>
        )
      }
      select={
        <Select
          isMulti={false}
          async
          placeholder="название компании, ЛС компании, серийный номер устройства, почта пользователя"
          selected={selectedCompany}
          handleSelect={handleSelect}
          loadOptions={_.debounce(loadCompaniesPromise, 350, { leading: true })}
          defaultOptions
        />
      }
      actions={
        selectedCompany && (
          <>
            <Button size="small" secondary onClick={() => setLinkDeviceModal(true)} rounded>
              <Link style={{ marginRight: 8 }} />
              привязать устройства
            </Button>
            <Button size="small" secondary onClick={() => setSendMoneyModal(true)} rounded>
              <AttachMoney style={{ marginRight: 8 }} />
              насыпать денег
            </Button>
            <Button size="small" secondary onClick={() => setExpenseBillingModal(true)} rounded>
              <AttachMoney style={{ marginRight: 8 }} />
              Списать денег
            </Button>
          </>
        )
      }
    >
      {selectedCompany && (
        <>
          <Switch>
            <Route exact path={`${match.url}/tracks`} component={Tracks} />
            <Route exact path={`${match.url}/about`} component={AboutCompany} />
            <Route path={`${match.url}/invoices`} component={Invoices} />
            <Route path={`${match.url}/operations`} component={Operations} />
            <Route path={`${match.url}/services`} component={Services} />
            <Route path={`${match.url}/analytics`} component={Analytics} />
            <Route path={match.url} component={Devices} />
          </Switch>
        </>
      )}
      <SearchIntercomModal
        open={intercomSearchOpen}
        handleClose={() => setIntercomSearch(false)}
        handleIntercomSearch={handleIntercomSearch}
      />
      <SendMoneyModal open={sendMoneyModal} handleClose={() => setSendMoneyModal(false)} />
      <LinkDeviceModal open={linkDeviceModal} handleClose={() => setLinkDeviceModal(false)} />
      <ExpenseBillingModal
        open={expenseBillingModal}
        handleClose={() => setExpenseBillingModal(false)}
      />
    </CompaniesTemplate>
  )
}

type Props = {
  match: Match,
  history: Object,
  dispatch: Function,
  billingAccount: BillingAccount,

  invoices: Object,
  selectedCompany: {
    label: string,
    value: string,
    identifier: string,
  },
}

const mapStateToProps = ({ auth, companies }) => ({
  invoices: companies.invoices,
  selectedCompany: companies.selected,
})

export default withRouter(connect(mapStateToProps)(CompaniesPage))
